<template>
	<textarea
		ref="textarea"
		:rows="rows"
		@input="resize"
		class="rounded-lg"
		:class="[
			markInvalid
				? 'text-red-500 border-red-500 shadow-sm focus:text-gray-900'
				: '',
		]"
		v-model="val"
	></textarea>
</template>

<script>
// "inspired by"
// https://stackoverflow.com/questions/65997180/automatic-resizing-of-textarea-after-loading-data-in-vue
// https://medium.com/@adamorlowskipoland/vue-auto-resize-textarea-3-different-approaches-8bbda5d074ce

export default {
	props: {
		value: {
			required: true,
		},
		markInvalid: {
			type: Boolean,
			default: false,
		},
		rows: {
			type: Number,
			default: 1,
		},
	},
	data() {
		let val = this.value ? "" + this.value : "";
		return {
			val: val,
		};
	},
	methods: {
		resize() {
			const { textarea } = this.$refs;
			textarea.style.height = "auto";
			textarea.style.height = `${textarea.scrollHeight}px`;
		},
	},
	watch: {
		val(v) {
			this.$emit("input", this.val);
			this.$emit("change");
		},
		value(v) {
			this.val = v; // if prop is updated
			this.$nextTick(() => this.resize());
		},
	},
	created() {
		//this.$nextTick( () => this.resize() );
	},
};
</script>
